module.exports = __webpack_public_path__ + "images/blog/blog_balloon/woman_bbe9a9887c115814be93de17ea7936ef.png";